import { Combobox, CustomTable, CustomTableRef, Modal, ResponseDTO } from 'medere-ui-framework'
import { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useManagerService } from '../../../servicesHooks/Manager/useManagerService';
import { AxiosResponse } from 'axios';
import { Toast, ToastMessage } from 'primereact/toast'
import { HealthEntityBasicDataDTO } from '../../../interface/HealthEntityBasicDataDTO';
import { ComboDataDTO } from '../../../dto/ComboDataDTO';

export default function ManagerHealthEntity({medereentity}:{medereentity:number}) {
    //const dispatch = useDispatch();
    const { addHealthEntityToManager, getAllHealthEntitiesToAddToManager, getHealthEntitiesByManager, removeHealthEntityFromManager } = useManagerService();
    const [errorHealthEntity, setErrorHealthEntity] = useState(false);
    const [healthEntity, setHealthEntity] = useState<ComboDataDTO | null>(null) // Data of ComboBox healthEntity
    //const {currentOffice} = useCurrentOffice();
    const refTable = useRef<CustomTableRef>(null);
    const [healthEntityToDelete, setHealthEntityToDelete] = useState<number>(-1); // Data of ComboBox healthEntity
    const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);

    const toast = useRef<any>(null)
    const showMessage = (ref: React.RefObject<Toast>, msg: any, severity: ToastMessage['severity']) => {
        ref.current?.show({ severity: severity, summary: msg, life: 3000 });
    };

    useEffect(()=>{
        if(healthEntityToDelete > 0){
            setConfirmDeleteModal(true)
        }
    },[healthEntityToDelete])

    function handleAddHealthEntityToManager(){
        if(healthEntity && healthEntity.id){
            addHealthEntityToManager(healthEntity.id, medereentity).then((res:AxiosResponse<ResponseDTO>) => {
                if(res.status === 200){
                    if(res.data.success){
                        setHealthEntity(null)
                        showMessage(toast, "Se ha agregado exitosamente la obra social a la gerenciadora", 'success')
                        //dispatch(setNotification({title:"Se ha agregado exitosamente la obra social a la gerenciadora", typeOfNotification:ETypeOfNotification.INFO}))
                        refTable.current?.refreshTable?.();
                    } else {
                        showMessage(toast, res.data.errormessage, 'error')
                        //dispatch(setNotification({desc:res.data.errormessage, typeOfNotification:ETypeOfNotification.ERROR}))
                    }
                    
                } else {
                    showMessage(toast, "Ha ocurrido un error al agregar la obra social a la gerenciadora", 'error')
                    //dispatch(setNotification({title:"Ha ocurrido un error al agregar la obra social a la gerenciadora", typeOfNotification:ETypeOfNotification.ERROR}))
                }
            })
        }
    }

    function handleRemoveHealthEntityFromManager(){
        setConfirmDeleteModal(false)    
        if(healthEntityToDelete > 0){
            removeHealthEntityFromManager(healthEntityToDelete, medereentity).then((res:AxiosResponse) => {
                if(res.status === 200){
                    setHealthEntityToDelete(-1)
                    showMessage(toast, "Se ha eliminado exitosamente la obra social de la gerenciadora", 'success')
                    //dispatch(setNotification({title:"Se ha eliminado exitosamente la obra social de la gerenciadora", typeOfNotification:ETypeOfNotification.INFO}))
                    refTable.current?.refreshTable?.();
                } else {
                    showMessage(toast, "Ha ocurrido un error al eliminar la obra social de la gerenciadora", 'error')
                    //dispatch(setNotification({title:"Ha ocurrido un error al eliminar la obra social de la gerenciadora", typeOfNotification:ETypeOfNotification.ERROR}))
                }
            })
        }
    }


    return <div className='flex flex-column' style={{height: '500px'}}>

        <div className=' ml-3.5 mr-3.5 flex align-items-baseline'>
            <Combobox
                className="md:w-3 mr-2 mb-4"
                optionLabel="name"
                floatLabel
                label={"Ingresar obra social"}
                error={errorHealthEntity}
                value={healthEntity}
                getItems={getAllHealthEntitiesToAddToManager}
                params={{ managerId: medereentity}}
                setValue={(p: ComboDataDTO) => {
                    setHealthEntity(p);
                    setErrorHealthEntity(false);
                }} />
            <Button
              icon="pi pi-plus"
              rounded
              disabled={!healthEntity}
              className='buttonSecondary-primaryColor'
              onClick={handleAddHealthEntityToManager} />

        </div>
        
        <CustomTable 
            className='ml-3.5 mr-3.5'
            getItems={getHealthEntitiesByManager}
            ref={refTable}
            idTable='healthEntitiesByManager' 
            hideFiltersButton
            onDeleteHandler={(p:HealthEntityBasicDataDTO)=>{
                setHealthEntityToDelete(p.medereentity)
            }}
            params={{ managerId: medereentity}}
        >
            <Column field="commercialname" header="Nombre" />
            <Column field="businessname" header="Nom. Fiscal" />
            <Column field="document" header="CUIT" />
        </CustomTable>

        <Modal visible={confirmDeleteModal} setVisible={setConfirmDeleteModal} header="Confirmacion"
          footerButtonRightText="Eliminar" footerButtonLeftText="Cancelar" onHideCustom={() => setHealthEntityToDelete(-1)}
          onClickLeftBtn={() => {
            setHealthEntityToDelete(-1)
            setConfirmDeleteModal(false)
          
          }} onClickRightBtn={handleRemoveHealthEntityFromManager}>
          Estas seguro que deseas eliminar esta obra social de esta gerenciadora?
        </Modal>
    </div>
}
